<template>
    <component :is="component" v-bind="componentProps" class="variant-flat btn-add-to-cart" @click="onVariantSelect">
        <VariantItem class="variant-flat__item">
            <template #title>{{ title }}</template>

            <template #subtitle>
                <div class="variant-flat__subtitle">
                    <div v-if="!variant.selectionText" class="variant-flat__features d-flex flex-wrap">
                        <!-- Hotel Voucher case -->
                        <!-- After access code products introduction variant features became nullable -->
                        <!--            <span v-if="personsComputed" class="feature">{{ personsComputed }}</span>-->
                        <span v-if="variant.persons" class="feature">{{ variant.persons }}</span>
                        <span v-if="variant.roomType" class="feature">{{ variant.roomType }}</span>
                        <span v-if="variant.catering" class="feature">{{ variant.catering }}</span>
                        <span v-if="variant.additionalFeature" class="feature">
                            {{ variant.additionalFeature }}
                        </span>
                    </div>

                    <MarketingHint
                        v-if="variant.marketingHint"
                        :marketingHint="variant.marketingHint"
                        class="variant-flat__hint"
                    />
                </div>
            </template>

            <template #price>
                <Price
                    v-if="price"
                    :minimumPrice="packagePrice"
                    :minimum-per-person-price="perPersonPrice"
                    :minimum-per-night-price="perNightPrice"
                    :ignore-price-mode="ignorePriceMode"
                    :showPrefix="false"
                    :hide-help="ignorePriceMode"
                    class="variant-price variant-flat__price"
                >
                </Price>

                <span v-else class="variant-price price">
                    {{ $t('Generic.inclusive') }}
                </span>
            </template>

            <template #hint>
                <media-only desktop class="m-auto">
                    <IconSvg filepath="basket.svg" class="variant-flat__icon-basket"></IconSvg>
                </media-only>
            </template>
        </VariantItem>
    </component>
</template>

<script>
import Price from '@/components/Price.vue';
import MarketingHint from '@/components/product/MarketingHint.vue';
import VariantItem from '@/components/product/selection/VariantItem.vue';

export default {
    name: 'VariantItemFlat',
    components: {
        Price,
        MarketingHint,
        VariantItem
    },

    props: {
        variant: Object,
        arrivalDate: String,
        isVoucher: Boolean,
        isAuctionOffer: Boolean
    },

    computed: {
        title() {
            return this.variant.duration || this.variant.selectionText;
        },
        externalCheckoutData() {
            return this.variant.externalCheckoutData;
        },
        component() {
            if (!this.isAuctionOffer) {
                return 'nuxt-link';
            }
            return 'button';
        },
        componentProps() {
            if (!this.isAuctionOffer) {
                return {
                    to: this.link
                };
            }
            return {
                class: 'btn'
            };
        },
        link() {
            const { arrivalDate, variant, isVoucher } = this;
            return {
                name: 'checkout',
                query: Object.assign(
                    {
                        [isVoucher ? 'voucherProductId' : 'productVariantId']: variant.id,
                        quantity: 1
                    },
                    arrivalDate && { arrivalDate }
                )
            };
        },
        price() {
            return (
                this.variant.price.regularPriceValues ||
                //in case if a multivoucher variant has a surcharge
                (this.variant.price.surcharge && {
                    price: this.variant.price.surcharge
                })
            );
        },
        isMainShop() {
            return this.$store.getters.isMainShop;
        },
        packagePrice() {
            if (this.isAuctionOffer) {
                return this.price.listPrice;
            }
            return this.price.price;
        },
        perPersonPrice() {
            return this.isMainShop ? this.price.perPersonPrice : null;
        },
        perNightPrice() {
            return this.isMainShop ? this.price.perPersonPerNightPrice : null;
        },
        ignorePriceMode() {
            return (
                !this.isMainShop ||
                (this.price.perPersonPrice == null && this.price.perPersonPerNightPrice == null) ||
                this.isAuctionOffer
            );
        }
    },

    methods: {
        onVariantSelect() {
            this.$emit('variantSelected', this.variant);
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/bootstrap/_breakpoints.scss' as breakpoints;
@use '@/styles/theming' as *;

.variant-flat {
    $self: &;

    text-decoration: none;

    &.btn {
        width: 100%;
        padding: 0;
        text-align: start;
    }

    &__item {
        min-height: 90px; // 90 makes all variant buttons look consistent, fits tile + 2 lines subtitle, prevents cls
    }

    &__hint {
        border-radius: 100px;
        font-size: 13px;
        line-height: 1.2;
        padding-top: 2px;
        padding-bottom: 2px;
    }

    &__features {
        span.feature:not(:last-of-type):after {
            content: ', ';
            white-space: pre;
        }
    }

    &__price {
        display: block;
    }

    &__icon-basket {
        display: none;
        color: inherit;
    }

    &:hover {
        #{$self}__icon-basket {
            display: block;
        }
    }
}
</style>
